import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "footer_fb",
  "use": "footer_fb-usage",
  "viewBox": "0 0 8 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid\" viewBox=\"0 0 8 17\" id=\"footer_fb\"><path d=\"M5.329 16.985H1.774V8.492H-.002V5.564h1.776V3.808C1.774 1.421 2.777 0 5.626 0h2.372v2.928H6.516c-1.109 0-1.183.409-1.183 1.172l-.004 1.464h2.686l-.314 2.928H5.329v8.493Z\" class=\"footerfb1\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol